<template>
  <div class="list-info-box">
    <div class="main-container">
      <h2 class="">宿泊情報詳細</h2>

      <div class="info-box">
        <div class="lodg-info">
          <p class="info-title">部屋名</p>
          <p class="info-item">{{lodg_data.listing_name}}</p>
          <p class="info-title">代表者名</p>
          <p class="info-item">{{lodg_data.name}}</p>
          <p class="info-title">チェックイン日</p>
          <p class="info-item">{{lodg_data.check_in}}</p>
          <p class="info-title">チェックアウト日</p>
          <p class="info-item">{{lodg_data.check_out}}</p>
          <p class="info-title">代表者 email</p>
          <p class="info-item">{{lodg_data.email}}</p>
          <p class="info-title">人数 / 実人数</p>
          <p class="info-item">{{lodg_data.customer_num}} / {{lodg_data.disp_customer_num}}</p>
          <p class="info-title">言語</p>
          <p class="info-item">{{select_lang[lodg_data.language]}}</p>

          <input type="button" class="lodg-edit" @click="lodg_edit" v-if="back == 'unregistered' || back == 'unaccepted' || back == 'accepted'" value="宿泊情報を編集" />
        </div>

        <div class="list-box">
          <div class="remand-box" v-if="remand_flg == true">
            <h2>差戻し理由</h2>
            <textarea name="name" rows="8" cols="80" v-model="remand_text"></textarea>
            <input type="button" class="new-add" @click="remand" value="送信" />
            <p class="warning sidenote" v-if="!lodg_data.email">{{ "代表者emailが設定されていないため、\n1人目(代表者)のemail" }} <b>「{{ rep_email }}」</b>を代表者emailに登録し、メール送信します。</p>
          </div>

          <div class="remand-box" v-if="remand_data">
            <h2>差戻し理由</h2>
            <div class="">
              {{remand_data.remand_text}}
            </div>
            <p class="remand-date">差戻し日：{{remand_data.date}}</p>
          </div>

          <div class="list-header-box">
            <div class="flex">
              <p class="list-item1"></p>
              <p class="list-item2">名前</p>
              <p class="list-item3">国籍</p>
              <p class="list-item3">認証</p>
            </div>
          </div>

          <div class="list-contents-box">
            <div class="flex" v-for="(list, index) in lists" :key="index">
              <p class="list-item1">{{index + 1}}人目<span v-if="index == 0">(代表者)</span></p>
              <p class="list-item2"><a class="" @click="list_info(list, index)">{{(list.name) ? list.name : '未登録'}}</a></p>
              <p class="list-item3">{{list.nationality}}</p>
              <p class="list-item3 center">{{face_chk(list.recognized_flag)}}</p>
            </div>
          </div>
        </div>
      </div>




      <!-- <div class="list-box">
        <div class="flex">
          <div class="list-header-box">
            <p class="">代表者名</p>
          </div>
          <div class="list-contents-box">
            <p class="list-item1">{{lodg_data.name}}</p>
          </div>
        </div>
        <div class="flex">
          <div class="list-header-box">
            <p class="">代表者 email</p>
          </div>
          <div class="list-contents-box">
            <p class="list-item1">{{lodg_data.email}}</p>
          </div>
        </div>
        <div class="flex">
          <div class="list-header-box">
            <p class="">宿泊日</p>
          </div>
          <div class="list-contents-box">
            <p class="list-item2">{{lodg_data.check_in}}</p>
          </div>
        </div>
        <div class="flex">
          <div class="list-header-box">
            <p class="">人数</p>
          </div>
          <div class="list-contents-box">
            <p class="list-item3">{{lodg_data.customer_num}}</p>
          </div>
        </div>
        <div class="flex">
          <div class="list-header-box">
            <p class="list-item3">言語</p>
          </div>
          <div class="list-contents-box">
            <p class="">{{select_lang[lodg_data.language]}}</p>
          </div>
        </div>
      </div> -->



      <div class="btn-box">
        <input type="button" class="new-add" @click="back_list" value="戻る" />
        <input type="button" class="new-add" v-if="back == 'unaccepted'" @click="accept" value="承認" />
        <input type="button" class="new-add" v-if="lodg_data.status == 4 && check_in_status != 1" @click="check_in_ok" value="Check-in済み" />
        <input type="button" class="new-add btn-red" v-if="lodg_data.status == 4 && check_in_status == 1" @click="check_in_cancel" value="Check-in取消" />
        <input type="button" class="new-add btn-red" v-if="back == 'unaccepted' || back == 'accepted'" @click="remand_flg_set" value="差戻" />
        <input type="button" class="new-add btn-red cancel-btn" v-if="back != 'canceled'" @click="cancel" value="Cancel" />
        <input type="button" class="new-add btn-red cancel-btn" v-if="back == 'canceled'" @click="cancel_del" value="Cancel取消" />
      </div>

    </div>
  </div>
</template>

<script>
import ManageCustomerEdit from '@/views/popup/ManageCustomerEdit';
import CustomerInfo from '@/views/popup/CustomerInfo';
export default {
  name: 'ListInfo',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      lodg_data: {},
      check_in_status: 0,
      select_lang: {'en': '英語', 'ja': '日本語'},
      back: null,
      lists: [],
      remand_flg: false,
      remand_text: null,
      remand_data: null,
      lodg_id: 0,
      rep_email: ""
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    this.back = this.$route.params.back;
    this.lodg_id = this.$route.params.lodg_id;
    if (!this.lodg_id) {
      this.$router.push({name: 'unregistered', params: {}});
      return;
    }

    this.data_get();
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    data_get () {
      let ld = new this.$loader(this);
      ld._data_set({id: this.lodg_id});
      ld._post_cb_f = this.data_get_cb;
      ld._load_start('list_info_get.php');
    },
    data_get_cb (res) {
      this.lodg_data = res.data.lodg_data;
      this.check_in_status = res.data.check_in_status;
      this.lists = res.data.customer_list;
      this.remand_data = res.data.remand;
      this.rep_email = res.data.representative_customer_email;
    },
    back_list () {
      this.$router.push({name: this.back, params: {}});
    },
    accept () {
      let text = '承認しますか？';
      if (!this.lodg_data.email) {
        text += `\n\n代表者emailが設定されていないため、\n1人目(代表者)のemail「${this.rep_email}」を代表者emailに登録し、メール送信します。`;
      }
      this.$alert('alert', text, this.accept_cb);
    },
    accept_cb () {
      let ld = new this.$loader(this);
      ld._data_set({id: this.lodg_data.id});
      ld._post_cb_f = this.accept_cb2;
      ld._load_start('accept.php');
    },
    accept_cb2 () {
      this.$alert('info', '承認しました。');
      this.back_list();
    },
    remand_flg_set () {
      this.remand_flg = !this.remand_flg;
    },
    remand () {
      if (this.$lib._emptyChk(this.remand_text) === false) {
        this.$alert('alert', '差戻し理由を入力してください。');
        return;
      }
      this.$alert('alert', '差戻しますか？', this.remand_cb);
    },
    remand_cb () {
      let ld = new this.$loader(this);
      ld._data_set({id: this.lodg_data.id, remand_text: this.remand_text});
      ld._post_cb_f = this.reject_cb;
      ld._load_start('reject.php');
    },
    reject_cb () {
      this.$alert('info', '差戻しました。');
      this.back_list();
    },
    cancel () {
      this.$alert('alert', 'キャンセルしますか？', this.cancel_cb);
    },
    cancel_cb () {
      let ld = new this.$loader(this);
      ld._data_set({id: this.lodg_data.id});
      ld._post_cb_f = this.cancel_cb2;
      ld._load_start('cancel.php');
    },
    cancel_cb2 () {
      this.$alert('info', 'キャンセルしました。');
      this.back_list();
    },
    cancel_del () {
      this.$alert('alert', 'キャンセルを取り消しますか？', this.cancel_del_cb);
    },
    cancel_del_cb () {
      let ld = new this.$loader(this);
      ld._data_set({id: this.lodg_data.id});
      ld._post_cb_f = this.cancel_del_cb2;
      ld._load_start('resume.php');
    },
    cancel_del_cb2 () {
      this.$alert('info', 'キャンセルを取り消しました。');
      this.back_list();
    },
    list_info (list, index) {
      if (this.$lib._emptyChk(list.name) === false) {
        this.$alert('alert', '未登録のため、表示できません。');
        return;
      }
      this.$popup(CustomerInfo, null, {list: list, index: index, height: this.$root.$el.offsetHeight, cb: this.user_edit, type: 'manage'});
    },
    lodg_edit () {
      this.$router.push({name: 'lodging_add', params: {mode: 'edit', id: this.lodg_data.id, back: this.back}});
    },
    user_edit (list, index) {
      this.$popup(ManageCustomerEdit, null, {list: list, lodg_data: this.lodg_data, index: index, height: this.$root.$el.offsetHeight, cb: this.data_get});

    },
    face_chk (flg) {
      if (flg === 1) {
        return '済';
      } else if (flg === 2) {
        return '失敗';
      }
      return '';
    },
    check_in_ok () {
      this.$alert('alert', 'Check-inを確認済みにしますか？', this.check_in_ok_cb);
    },
    check_in_ok_cb () {
      let ld = new this.$loader(this);
      ld._data_set({
        id: this.lodg_id,
        check_in_status: 1,
      });
      // ld._post_cb_f = this.data_get;
      ld._post_cb_f = () => {
        this.$router.push({ name: 'accepted', params: {} });
      };
      ld._load_start('admin_user_check_in_status_edit.php');
    },
    check_in_cancel () {
      this.$alert('alert', 'Check-in確認済みを取り消しますか？', this.check_in_cancel_cb);
    },
    check_in_cancel_cb () {
      let ld = new this.$loader(this);
      ld._data_set({
        id: this.lodg_id,
        check_in_status: 0,
      });
      // ld._post_cb_f = this.data_get;
      ld._post_cb_f = () => {
        this.$router.push({ name: 'accepted', params: {} });
      };
      ld._load_start('admin_user_check_in_status_edit.php');
    }
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.list-info-box {
  text-align: left;

  .main-container {
    .btn-box {
      display: flex;
      margin: 10px auto 0 auto;

      // position: sticky;
      padding: 10px 0 10px 10px;
      // bottom: 0;
      background:#d7d7da;

      input {
        margin-right: 10px;
      }

      z-index: 900;
    }
    .new-add {
      color: #fefefe;
      display: block;
      text-align: center;
      padding: 8px;
      font-size: 16px;
      border-radius: 3px;
      width: 150px;
    }
    .lodg-edit {
      color: #fefefe;
      display: block;
      text-align: center;
      padding: 8px;
      font-size: 16px;
      border-radius: 3px;
      width: 150px;
      margin: 30px auto 0 auto;
    }
    .btn-red {
      color: #b95a3a;
      font-size: 16px;
      text-decoration: none;
      border-radius: 3px;
      width: 150px;
      font-weight: 800;
      background-color: #f6f6f7;
      border: 1px solid #b95a3a;
      transition: all 0.2s ease;
    }
    .btn-red:hover {
      color: #24273b;
      border: 1px solid #24273b;
    }
    .info-box {
      display: flex;
    }

    .lodg-info {
      width: 260px;
      padding: 10px;
      background: #fbfbfb;
      margin-right: 10px;
      border: 1px solid #d3d4d8;
    }

    .info-title {
      padding: 3px;
      color: #ff6e5a;
      font-size: 0.9rem;
    }

    .info-item {
      padding: 3px 3px 3px 13px;
      font-size: 0.9rem;
    }

    .list-box {
      overflow-y: auto;
      height: calc(100vh - 225px);
      flex: 1;
    }
    .list-header-box {
      position: sticky;
      top: 0;
      p {
        background: #fbfbfb;
        border-top: 1px solid #d3d4d8;
        border-left: 1px solid #d3d4d8;
        border-bottom: 1px solid #d3d4d8;
        padding: 10px;
        color: #24273b;

        text-align: center;
        box-sizing: border-box;
        height: 46px;
      }
      p:last-child {
        border-right: 1px solid #d3d4d8;
      }
    }
    .list-contents-box {

      p {
        border-bottom: 1px solid #d3d4d8;
        border-left: 1px solid #d3d4d8;
        padding: 8px;

        box-sizing: border-box;
        height: 40px;
        background: #fbfbfb;
        font-size: 0.9rem;
      }
      p:last-child {
        border-right: 1px solid #d3d4d8;
      }
    }
    .list-item1 {
      min-width: 120px;
      max-width: 120px;
    }
    .list-item2 {
      min-width: 120px;
      flex: 1;
      font-size: 1rem !important
    }
    .list-item3 {
      min-width: 100px;
      max-width: 100px;
    }
    .remand-box {
      border: 1px solid #d3d4d8;
      background: #fbfbfb;
      padding: 20px;
      margin: 0 0 20px 0;
      .warning {
        color: #d82a15;
        margin-top: 12px;
        white-space: pre-wrap;
      }
    }
    .remand-date {
      background: #efefef;
      padding: 5px;
      margin: 10px 0 0 0;
    }
    // .list-box {
    //   display: flex;
    //   flex-flow: wrap;
    //   border-left: 1px solid #cecece;
    // }
    // .list-header-box {
    //   p {
    //     width: 120px;
    //     background: #fefefe;
    //     border-top: 1px solid #cecece;
    //     padding: 10px;
    //
    //     text-align: right;
    //     box-sizing: border-box;
    //     height: 46px;
    //   }
    //   p:last-child {
    //     border-bottom: 1px solid #cecece;
    //   }
    // }
    // .list-contents-box {
    //   border-right: 1px solid #cecece;
    //   flex: 1;
    //   p {
    //     border-top: 1px solid #cecece;
    //     border-left: 1px solid #cecece;
    //     border-bottom: 1px solid #cecece;
    //     padding: 8px;
    //     line-height: 2;
    //     min-width: 200px;
    //
    //     box-sizing: border-box;
    //     height: 46px;
    //   }
    //   p:last-child {
    //   }
    //   select,
    //   input[type="url"]
    //   input[type="text"] {
    //     height: 29px;
    //   }
    //   input[type="number"] {
    //     height: 25px;
    //   }
    // }
    .sidenote {
      position: relative;
      padding-left: 16px;
      &::before {
        content: '※';
        display: block;
        position: absolute;
        left: 0;
      }
    }
  }
  @media (max-width: 767px) {
    .main-container {
      .info-box {
        display: block;
      }

      .lodg-info {
        width: calc(100vw - 42px);
        margin-bottom: 10px;
      }
      .list-box {
        overflow-y: visible;
        height: auto;
      }
      // .list-box {
      //   display: block;
      // }
      // .list-header-box {
      //   width: 120px;
      // }
    }
  }
}
</style>
